import { BREAKPOINT_LARGE_DESKTOP_PX } from '../global/constants'
import { useMediaQuery } from '../global/useMediaQuery'

export const useIsLargeScreen = (): boolean => {
  return useMediaQuery(`(min-width: ${BREAKPOINT_LARGE_DESKTOP_PX}px)`)
}
